import ErrorIcon from "components/svg-icons/error-icon";
import { IMaterial } from "./type-definitions";

const MATERIAL_SCROLL_LIST_MAX_VISIBLE_ITEMS = 4;
const MATERIAL_SCROLL_LIST_MAX_HEIGHT_CLASS = "max-h-[115px]";

export function VerticalList({
  items,
  onChange,
  activeKey
}: {
  items: { label: any; key: string; hasTopSeparator?: boolean }[];
  onChange: (item: any) => void;
  activeKey: string | null;
}) {
  return (
    <div className="py-0.5">
      {items.map((item) => (
        <div key={item.key}>
          {item.hasTopSeparator && (
            <div className="border-0 border-t border-solid border-color-3 my-1" />
          )}
          <button
            role="tab"
            type="button"
            tabIndex={0}
            className={`bg-white cursor-pointer w-full px-6 py-2.5 pr-5 border-0 border-r-2 border-transparent border-solid ${
              activeKey === item.key
                ? "!bg-ciq-gray-100 !border-ciq-black-a88 font-semibold"
                : ""
            }`}
            onClick={() => {
              onChange(item.key);
            }}
            data-testid={`vertical-list-item-${item.key}`}
          >
            {item.label}
          </button>
        </div>
      ))}
    </div>
  );
}

export function VerticalListItem({
  label,
  subLabel,
  hasWarningIcon
}: {
  label: string;
  subLabel?: string;
  hasWarningIcon?: boolean;
}) {
  return (
    <div className="text-left w-full max-w-full">
      <div className="flex items-center justify-between">
        <div className="w-full max-w-full overflow-hidden">
          <div className="text-sm text-color-1 max-w-full overflow-hidden truncate">
            {label}
          </div>
          {subLabel && (
            <div className="text-xs text-color-2 italic max-w-full overflow-hidden truncate">
              {subLabel}
            </div>
          )}
        </div>
        {hasWarningIcon && (
          <div
            className="danger-text flex items-center justify-center ml-1 pt-0.5"
            data-testid="info-icon"
          >
            <ErrorIcon width={17} height={17} />
          </div>
        )}
      </div>
    </div>
  );
}

export function MaterialScrollList({ materials }: { materials: IMaterial[] }) {
  const needsScroll = materials.length > MATERIAL_SCROLL_LIST_MAX_VISIBLE_ITEMS;

  return (
    <div
      className={`rounded bg-ciq-gray-100 ${
        needsScroll
          ? `overflow-y-auto ${MATERIAL_SCROLL_LIST_MAX_HEIGHT_CLASS}`
          : "overflow-hidden"
      }`}
      data-testid="material-scroll-list"
    >
      {materials.map((material, index) => (
        <div
          key={material.id}
          data-testid={`material-list-item-${material.id}`}
        >
          <div className="px-4 h-7 flex items-center text-xs text-color-1 truncate">
            {material.name}
          </div>
          {index < materials.length - 1 ? (
            <div
              className="mx-4 border-0 border-b border-solid border-color-1"
              aria-hidden="true"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
}

export function MaterialListItem({
  material,
  additionalClassName
}: {
  material: IMaterial;
  additionalClassName?: string;
}) {
  return (
    <div
      className={`text-xs border-0 border-solid border-b ${additionalClassName ?? ""} px-4 h-7 flex items-center text-color-1 truncate`}
      key={material.id}
      data-testid={`material-list-item-${material.id}`}
    >
      {material.name}
    </div>
  );
}
